import { Box, Button, Divider, Stack, Typography, useTheme } from '@mui/material';
import useTenantRegistrationInfo from 'hooks/useTenantRegistrationInfo/useTenantRegistrationInfo';
import React from 'react';
import { useSearchParams } from 'react-router';
import EntraId from 'v2/assets/vector/EntraId';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import { useWizardStepContext } from 'v2/components/WizardModal';
import useGoBackOneOnboardingStep from 'v2/hooks/onboarding/useGoBackOneOnboardingStep/useGoBackOneOnboardingStep';

const STEP_INDEX = 0;

const ConnectEntraIDStep = () => {
  const theme = useTheme();
  const { setFooterContent, steps, goToPrev } = useWizardStepContext();
  const { showSnackbar } = useSnackbarContext();
  const handleFetchError = (errorMessage: string) => showSnackbar(errorMessage, { severity: 'error' });
  const { tenantRegistrationInfo } = useTenantRegistrationInfo({
    handleFetchError
  });
  const { goBackOneOnboardingStep, loading: goBackOneOnboardingStepLoading } = useGoBackOneOnboardingStep({
    handleFetchError
  });

  const [searchParams] = useSearchParams();
  const jwt = searchParams.get('id');

  const handleOnConnectButtonClick = () => {
    if (tenantRegistrationInfo?.entraAdminConsentUrl !== undefined && jwt !== null) {
      window.location.href = `${tenantRegistrationInfo.entraAdminConsentUrl}&state=${jwt}`;
    }
  };

  const onBackButtonClick = async () => {
    if (!goBackOneOnboardingStepLoading) {
      const result = await goBackOneOnboardingStep();
      if (result) goToPrev();
    }
  };

  React.useLayoutEffect(() => {
    setFooterContent(
      STEP_INDEX,
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column-reverse', md: 'row' }, gap: 2 }}>
        <Button
          key="device-group-name-step-submit"
          id="connect-entra-back-button"
          variant="contained"
          color="secondary"
          onClick={onBackButtonClick}
        >
          Back
        </Button>
      </Box>
    );
  }, [setFooterContent, steps, onBackButtonClick]);

  return (
    <Stack flexDirection="column" gap={2}>
      <Typography variant="h5" color="textPrimary">
        Connecting Microsoft EntraID
      </Typography>
      <Typography variant="body2" color="textPrimary">
        To connect your Microsoft EntraID environment with ATLAS, follow these steps:
      </Typography>
      <Stack flexDirection="column" gap={1}>
        <Divider />
        <Stack
          flexDirection="row"
          gap="1.5rem"
          alignItems="center"
          padding="0.5rem 0"
          width="100%"
          justifyContent="space-between"
        >
          <Stack alignItems="center" gap={2}>
            <EntraId fontSize="large" sx={{ color: theme.palette.text.primary }} />
            <Typography variant="body1" color="textPrimary">
              Microsoft EntraID
            </Typography>
          </Stack>
          <Stack width="13.75rem" gap={0.5}>
            <Button
              id="connect-button"
              fullWidth
              variant="contained"
              size="large"
              color="primary"
              onClick={handleOnConnectButtonClick}
            >
              Connect
            </Button>
          </Stack>
        </Stack>
        <Divider />
      </Stack>
    </Stack>
  );
};

export default ConnectEntraIDStep;
